import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { useNavigate } from 'react-router-dom';
import { QueryWrapper } from '../../query/QueryWrapper';
import { QuadQueryWrapper } from './QuadQueryWrapper';

export function QuadQuery() {
    const navigate = useNavigate();

    const handleCancelQuadQueryTool = () => {
        navigate(LocalRoutes.QuadDashboard);
    };

    const handleSaveQuadQueryToolComplete = () => {
        navigate(LocalRoutes.QuadDashboard);
    };

    return <QuadQueryWrapper/>;
}
